export default __webpack_public_path__ + "static/media/lobsterTheremin.03f39fb3.jpg";